<template>
  <modal name="loading-modal" :title="$t('STAY_REFRESH_HEADER')" :canClose="false">
    <div class="indicator">
      <div class="supporting">{{ $t('STAY_REFRESH_SUPPORTING') }}</div>
    </div>
  </modal>
</template>
<script>
export default {
}
</script>

<style lang="scss" scoped>

.indicator {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  .supporting {
    @include font('060');
  }
}
</style>
